// alertSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type AlertStatus = 'success' | 'error' | 'info' | 'warning';

export interface AlertItem {
  id: string;
  status: AlertStatus;
  message: { [key: string]: string };
}

export interface AlertState {
  alerts: AlertItem[];
}

const initialState: AlertState = {
  alerts: [],
};

const alertSlice = createSlice({
  name: 'alert',
  initialState,
  reducers: {
    showAlert: (state, action: PayloadAction<AlertItem>) => {
      state.alerts.push(action.payload);
    },
    hideAlert: (state, action: PayloadAction<string>) => {
      state.alerts = state.alerts.filter(alert => alert.id !== action.payload);
    },
    clearAllAlerts: state => {
      state.alerts = [];
    },
  },
});

export const { showAlert, hideAlert, clearAllAlerts } = alertSlice.actions;
export default alertSlice.reducer;
